import scrollTo from '@eclass/scrollmove'

export const toScroll = (id: number) => {
  setTimeout(() => {
    scrollTo(`#comment-${id}`)
  }, 50)
}
